module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[38]525.1dabae6.woff2";